import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _cloneDeep from "lodash/cloneDeep";
import _get from "lodash/get";
import _omit from "lodash/omit";
import { isUnauthenticateAction } from "../utils/auth";
import { signin, signinWithOneTimeToken, register, authenticateWithGoogle, authenticateWithCorpIdp, authenticateWithApple, requestIdentity, preloadIdentity, setSecurityQuestion, signinWithRefreshToken, verifySmsCode, setTUAuthentication, updateEmail, createPassword } from "../actions";
import { AuthProviders } from "../constants";

var updateCurrentIdentity = function updateCurrentIdentity(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var identity = payload.identity;
  var enableHeadersAndMeta = meta.enableHeadersAndMeta;

  if (enableHeadersAndMeta) {
    identity = payload.data.identity;
  }

  return _omit(identity, 'profiles');
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = action.payload,
      meta = action.meta;

  if (isUnauthenticateAction(action)) {
    return {};
  }

  switch (action.type) {
    case signin.SUCCESS_TYPE:
    case signinWithOneTimeToken.SUCCESS_TYPE:
    case register.SUCCESS_TYPE:
    case authenticateWithGoogle.SUCCESS_TYPE:
    case authenticateWithApple.SUCCESS_TYPE:
    case authenticateWithCorpIdp.SUCCESS_TYPE:
    case signinWithRefreshToken.SUCCESS_TYPE:
    case requestIdentity.SUCCESS_TYPE:
      return updateCurrentIdentity(state, payload, meta);

    case preloadIdentity.getType():
      {
        var identity = _get(payload, 'IdentityStore.currentIdentity');

        return updateCurrentIdentity(state, {
          identity: identity
        });
      }

    case setSecurityQuestion.SUCCESS_TYPE:
      {
        var newState = _cloneDeep(state);

        newState.roles = newState.roles || [];
        newState.roles.push('nerdwallet/has_security_challenge');
        return newState;
      }

    case verifySmsCode.SUCCESS_TYPE:
      {
        var _newState = _cloneDeep(state);

        _newState.roles = _newState.roles || [];

        _newState.roles.push('nerdwallet/has_verified_phone');

        return _newState;
      }

    case setTUAuthentication.SUCCESS_TYPE:
      {
        var _newState2 = _cloneDeep(state);

        _newState2.roles = _newState2.roles || [];

        _newState2.roles.push('nerdwallet/has_activated_transunion');

        return _newState2;
      }

    case createPassword.SUCCESS_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          auth_providers: [].concat(_toConsumableArray(_get(state, 'auth_providers', [])), [AuthProviders.NERDWALLET]),
          has_password: true
        });
      }

    case updateEmail.SUCCESS_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          email: _get(meta, 'newEmail'),
          // changing email invalidates previous email verification
          verified_at: null
        });
      }

    default:
      return state;
  }
});